// src/App.js
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import AdminLayout from './components/AdminLayout';
import ProtectedRoute from './components/ProtectedRoute';
import AllVendors from './pages/AllVendors';
import AllProducts from './pages/AllProducts';
import AdminAddProduct from './pages/AdminAddProduct';
import AdminEditProduct from './pages/AdminEditProduct';
import AllUsers from './pages/AllUsers';
import CategoryManagement from './pages/CategoryManagement';
import AdminSettings from './pages/AdminSettings';
import TicketManagement from './pages/TicketManagement';

// Naya component: Agar logged in user galti se "/" pe aaye, toh wapas dashboard bhej do
const PublicRoute = ({ children }) => {
  const token = localStorage.getItem('adminToken');
  return token ? <Navigate to="/dashboard" replace /> : children;
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        
        {/* Public Route: Login Page (Agar token hai toh direct dashboard jayega) */}
        <Route 
          path="/" 
          element={
            <PublicRoute>
              <AdminLogin />
            </PublicRoute>
          } 
        />
        
        {/* SECURE ROUTES: Wrapped inside ProtectedRoute */}
        <Route element={<ProtectedRoute />}>
          
          <Route path="/dashboard" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="vendors" element={<AllVendors />} />
            <Route path="products" element={<AllProducts />} />
            <Route path="products/add" element={<AdminAddProduct />} />
            <Route path="products/edit/:id" element={<AdminEditProduct />} />
            <Route path="users" element={<AllUsers />} />
            <Route path="categories" element={<CategoryManagement />} />
            <Route path="tickets" element={<TicketManagement />} />
            <Route path="settings" element={<AdminSettings />} />
          </Route>

        </Route>

      </Routes>
    </BrowserRouter>
  );
}

export default App;